export const CUREWIKI_HOSTNAMES = [
  'app.curewiki.health',
  'app.qa-curewiki.health',
  'app-dev.qa-curewiki.health',
];

export const YWC_HOSTNAMES = ['yeswecan-cer.curewiki.health', 'app-dev-ywc.qa-curewiki.health'];
export const BHS_HOSTNAMES = ['bhs.curewiki.health', 'app-bhs.qa-curewiki.health'];
export const PCE_HOSTNAMES = ['pce.qa-curewiki.health', 'pce.curewiki.health'];
export const PEC_HOSTNAMES = ['app-pec.qa-curewiki.health', 'pec.curewiki.health'];
